import React from 'react'
import { ImportantFootnote } from '../../common/ImportantFootnote'
import { MdVerified } from 'react-icons/md'
import { RulerSeparator } from './RulerSeparator'

export const LegalAidOffice = () => {
  return (
    <>
      <RulerSeparator />
      <div className='flex flex-col gap-10 p-10'>
        <span className='flex items-center gap-2 justify-center'>
          <MdVerified color='#65C2D7' size='24' className='inline' />
          <h4 className='inline font-medium text-base text-[#093269] text-center'>
            Legal Aid Office
          </h4>
        </span>
        <ImportantFootnote
          className='text-[10px]'
          text='This information is supplied by the Legal Aid Agency. It is indicative only that this individual is located within an approved office for provision of legal aid funded legal services. '
        />
      </div>
    </>
  )
}
